import React, { useContext } from "react";
import MetaTags from "react-meta-tags";

//import Breadcrumbs
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { Col, Container, Row } from "reactstrap";
import EmailForwarders from "./EmailForwarders";
import { ThemeContext } from "src/helpers/themeContext";

const EmailForwardersPage = () => {
  const theme = useContext(ThemeContext)
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Email Forwarders | {theme.name} email forwarders</title>
        </MetaTags>

        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Home" breadcrumbItem="Email Forwarders" />

          <Row>
            <Col lg={12}>
              <EmailForwarders />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EmailForwardersPage;
